/* Sample policy shared by the product page, full cart and drawer. */
(function (scope) {
  'use strict';
  function sampleItem(item, feeId) {
    if (String(item.variant_id || item.id) === String(feeId)) return false;
    return item.properties?._sk_sample === '1' || item.isSample === true || /^Muster\s*-?/i.test(item.product_title || item.title || '');
  }
  function cartPolicy(cart, feeId, candidate) {
    const items = cart.items || [];
    const samples = items.filter(item => sampleItem(item, feeId));
    const normal = items.filter(item => String(item.variant_id || item.id) !== String(feeId) && !sampleItem(item, feeId));
    const count = samples.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const errors = [];
    if (samples.length && normal.length) errors.push('Muster und reguläre Artikel müssen getrennt bestellt werden.');
    if (count > 25) errors.push('Pro Bestellung sind höchstens 25 Muster möglich.');
    const skus = new Set();
    for (const item of samples) {
      const sku = String(item.sku || item.variant_id || item.id);
      if (Number(item.quantity) !== 1 || skus.has(sku)) errors.push('Jede Mustergröße kann nur einmal bestellt werden.');
      skus.add(sku);
    }
    if (candidate) {
      if (normal.length) errors.push('Bitte schließt eure reguläre Bestellung ab oder leert den Warenkorb, bevor ihr Muster bestellt.');
      if (count >= 25) errors.push('Die maximale Anzahl von 25 Mustern ist erreicht.');
      if (skus.has(String(candidate.sku || candidate.sampleVariantId))) errors.push('Diese Mustergröße liegt bereits im Warenkorb.');
      if (!candidate.available || Number(candidate.inventoryQuantity) <= 0) errors.push('Diese Mustergröße ist derzeit nicht verfügbar.');
    }
    return { valid: errors.length === 0, errors: [...new Set(errors)], hasSamples: samples.length > 0, hasNormal: normal.length > 0, sampleCount: count, samples };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { sampleItem, cartPolicy };
  if (typeof document === 'undefined' || !scope.SkQuotation) return;
  const api = scope.SkQuotation;
  function requireFeeConfiguration() {
    if (api.config.sampleFeeConfigurationValid === false) throw new Error('Die Mustergebühr ist noch nicht vollständig eingerichtet.');
  }
  let refreshing;
  let mutation;
  const service = scope.SkSamples = {
    cart: null,
    feeId: String(api.config.sampleFeeVariantId || ''),
    sampleItem, cartPolicy,
    async fetchCart() {
      const response = await fetch(api.shopPath('cart.js'), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
      service.cart = await response.json();
      return service.cart;
    },
    async lookup(variantId) {
      requireFeeConfiguration();
      const result = await api.request('samples.php?originalVariantId=' + encodeURIComponent(variantId));
      if (result.feeVariantId) {
        if (service.feeId && service.feeId !== String(result.feeVariantId)) throw new Error('Die Mustergebühr ist noch nicht vollständig eingerichtet.');
        service.feeId = String(result.feeVariantId);
      }
      return result;
    },
    async validate(cart) {
      requireFeeConfiguration();
      let local = cartPolicy(cart, service.feeId);
      // Until the backend supplies the fee ID, an existing fee can look like a regular item.
      if (!local.valid && service.feeId) return local;
      const remote = await api.request('samples.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'validate', cart: { items: cart.items } })
      });
      if (remote.feeVariantId) {
        if (service.feeId && service.feeId !== String(remote.feeVariantId)) throw new Error('Die Mustergebühr ist noch nicht vollständig eingerichtet.');
        service.feeId = String(remote.feeVariantId);
      }
      local = cartPolicy(cart, service.feeId);
      return { ...local, ...remote, valid: local.valid && remote.valid === true };
    },
    async update(updates) {
      const response = await fetch(api.shopPath('cart/update.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || 'Der Warenkorb konnte nicht aktualisiert werden.');
      service.cart = cart;
      return cart;
    },
    async normalizeFee(cart) {
      if (!service.feeId) return cart;
      const state = cartPolicy(cart, service.feeId);
      const fees = cart.items.filter(item => String(item.variant_id || item.id) === service.feeId);
      if (!state.hasSamples && fees.length) {
        const updates = {}; fees.forEach(item => { updates[item.key || item.variant_id || item.id] = 0; });
        return service.update(updates);
      }
      if (state.hasSamples && !state.hasNormal && !fees.length) {
        const response = await fetch(api.shopPath('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: service.feeId, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Die Mustergebühr konnte nicht hinzugefügt werden.');
        return service.fetchCart();
      }
      if (state.hasSamples && fees.length) {
        const updates = {}; let changed = false;
        fees.forEach((item, index) => { if (item.quantity !== (index === 0 ? 1 : 0)) { updates[item.key || item.variant_id || item.id] = index === 0 ? 1 : 0; changed = true; } });
        if (changed) return service.update(updates);
      }
      return cart;
    },
    refresh() {
      if (refreshing) return refreshing;
      refreshing = (async () => {
        let cart = await service.fetchCart();
        const initial = cartPolicy(cart, service.feeId);
        if (!service.feeId && initial.hasSamples && initial.hasNormal) {
          // Resolve a possible existing fee before painting a permanently disabled mixed cart.
          await service.validate(cart);
        }
        const before = JSON.stringify(cart.items.map(item => [item.key, item.quantity]));
        cart = await service.normalizeFee(cart);
        if (before !== JSON.stringify(cart.items.map(item => [item.key, item.quantity]))) await scope.SkDawn?.renderCart(false);
        document.dispatchEvent(new CustomEvent('sk:cart', { detail: { cart, policy: cartPolicy(cart, service.feeId) } }));
        return cart;
      })().finally(() => { refreshing = null; });
      return refreshing;
    },
    async add(originalVariantId) {
      if (mutation) return mutation;
      mutation = (async () => {
        const sample = await service.lookup(originalVariantId);
        if (!sample.sampleVariantId || !service.feeId) throw new Error('Muster und Mustergebühr sind noch nicht vollständig eingerichtet.');
        const cart = await service.fetchCart();
        const state = cartPolicy(cart, service.feeId, sample);
        if (!state.valid) throw new Error(state.errors[0]);
        const validation = await service.validate(cart);
        if (validation.valid === false) throw new Error((validation.errors || []).join(' '));
        const hasFee = cart.items.some(item => String(item.variant_id || item.id) === service.feeId);
        const items = [{ id: sample.sampleVariantId, quantity: 1, properties: { _sk_sample: '1', _sk_original_variant: String(originalVariantId) } }];
        if (!hasFee) items.push({ id: service.feeId, quantity: 1 });
        const response = await fetch(api.shopPath('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Das Muster konnte nicht hinzugefügt werden.');
        await service.refresh();
        await scope.SkDawn?.renderCart(true);
        api.notice('Das Muster wurde zum Warenkorb hinzugefügt.');
      })().finally(() => { mutation = null; });
      return mutation;
    }
  };
  document.addEventListener('DOMContentLoaded', () => service.refresh().catch(error => api.notice(error.message, true)), { once: true });
})(typeof window !== 'undefined' ? window : globalThis);
